import React from "react";

const fleetData = [
  {
    name: "Maruti Suzuki Dzire",
    desc: "The Maruti Suzuki Dzire is a popular compact sedan known for its excellent fuel efficiency, sleek design, and comfortable interiors — ideal for city rides and short outstation trips.",
    image: "/images/gallery/1.jpg",
  },
  {
    name: "Maruti Suzuki Ertiga",
    desc: "The Ertiga offers a perfect balance between space and comfort. Its 7-seater layout, stylish design, and efficient performance make it the top choice for family and group travel.",
    image: "/images/gallery/2.jpg",
  },
  {
    name: "Hyundai Aura",
    desc: "The Hyundai Aura is a compact sedan designed for premium comfort and style. With advanced safety features, plush interiors, and smooth performance, it’s perfect for urban and business trips.",
    image: "/images/gallery/3.jpg",
  },
  {
    name: "Hyundai City",
    desc: "The Hyundai City delivers sophistication and superior comfort. Its spacious cabin, responsive engine, and refined ride quality make it ideal for executive travel and family use.",
    image: "/images/gallery/4.jpg",
  },
  {
    name: "Toyota Innova Crysta",
    desc: "Renowned for its luxury and reliability, the Toyota Innova Crysta offers powerful performance, top-notch comfort, and spacious interiors — the preferred choice for long-distance journeys.",
    image: "/images/gallery/5.jpg",
  },
  {
    name: "Kia Carens",
    desc: "The Kia Carens combines style, comfort, and technology. With modern interiors, safety features, and flexible seating, it’s the perfect MPV for family tours and corporate rides.",
    image: "/images/gallery/6.jpg",
  },
  {
    name: "Maruti Suzuki Ciaz",
    desc: "The Maruti Suzuki Ciaz is a stylish sedan offering elegance, spacious legroom, and smooth handling — ideal for city commuting, airport transfers, and business executives.",
    image: "/images/gallery/7.jpg",
  },
  {
    name: "Maruti Suzuki Invicto",
    desc: "The Invicto redefines premium MPV travel with bold design, hybrid power, and luxury seating. Perfect for elite clients and long-distance comfort with a touch of class.",
    image: "/images/gallery/8.jpg",
  },
  {
    name: "Toyota Innova Crysta (Diesel)",
    desc: "A powerhouse of comfort and strength, the Toyota Innova Crysta Diesel variant offers unmatched long-trip reliability, plush interiors, and segment-leading performance.",
    image: "/images/gallery/9.jpg",
  },
  {
    name: "Toyota Innova Hycross",
    desc: "The Toyota Innova Hycross blends hybrid efficiency with luxury driving. Its futuristic design, powerful hybrid engine, and silent cabin make it a premium travel experience.",
    image: "/images/gallery/10.jpg",
  },
];




const OurFleet = () => {
  return (
    <>
      {/* Header Section */}



     <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>Our Fleets</h1>
          </div>
        </div>
      </section>

   
      

      {/* Fleet Cards */}
      <section className="fleet-section py-5">
        <div className="container">
          <div className="row gy-4">
            {fleetData.map((fleet, index) => (
              <div className="col-md-4" key={index}>
                <div className="fleet-card text-center p-4 h-100">
                  <div className="fleet-img mb-3">
                    <img
                      src={fleet.image}
                      alt={fleet.name}
                      className="img-fluid"
                    />
                  </div>
                  <h5 className="fleet-title">{fleet.name}</h5>
                  <p className="fleet-desc">{fleet.desc}</p>
                  
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurFleet;
